import React, { useState } from "react";
import { Button, Table, Pagination, Modal, Form } from "react-bootstrap";
import { PageSize } from "../../../Utility/constants";
import "./PersonalDetailsList.css";
import {
  BsPersonBadge,
  BsPersonVcard,
  BsFileEarmarkText,
  BsClipboardCheck,
  BsEye,
  BsCheckCircle,
  BsXCircle,
  BsArrowRepeat,
  BsTrash
} from "react-icons/bs";

const PersonalDetailsList = ({
  data,
  onEdit,
  onView,
  onOtherDetailsEdit,
  onAddNewStudent,
  onDelete,
  handleUpdateStatus,
  onDocsView,
  onLCOLView,
  handleSearch
}) => {
  const role = localStorage.getItem("Role");

  const [currentPage, setCurrentPage] = useState(1);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [searchCriteria, setSearchCriteria] = useState("Name"); // Default selected dropdown option
  const [searchValue, setSearchValue] = useState(""); // Textbox value

  // Calculate total pages
  const totalPages = Math.ceil(data.length / PageSize);

  // Calculate current data slice
  const currentData = data.slice(
    (currentPage - 1) * PageSize,
    currentPage * PageSize
  );

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Open the status modal and set the current student ID
  const handleOpenStatusModal = (studentId) => {
    setSelectedStudentId(studentId);
    setShowStatusModal(true);
  };

  // Handle status change
  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  // Submit status change to parent component
  const handleSubmitStatus = () => {
    if (selectedStudentId && selectedStatus) {
      const statusData = {
        studentId: selectedStudentId,
        status: selectedStatus,
        updatedBy: localStorage.getItem("userID"),
      };
      handleUpdateStatus(statusData); // Send status update to parent
      setShowStatusModal(false); // Close the modal
    }
  };

  const handleClearChange = (e) => {
    setSearchCriteria("0");
    setSearchValue("");
    handleSearch();
  };

  return (
    <>

      {(role === "ADMIN" || role === "TEACHER") && (
        <>
          <div className="row align-items-center mb-3">

            {/* Title */}
            <div className="col-md-3">
              <h2 className="mb-0">Student Details</h2>
            </div>

            {/* Search dropdown */}
            <div className="col-md-2">
              <select
                className="form-control"
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}
              >
                <option value="0">Select</option>
                <option value="grno">GR No</option>
                <option value="name">Name</option>
                <option value="rollno">Roll No</option>
                <option value="aadhaar">Aadhaar No</option>
              </select>
            </div>

            {/* Search input */}
            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter search value"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>

            {/* Search button */}
            <div className="col-md-1">
              <button
                className="btn btn-primary w-100"
                onClick={() => handleSearch(searchCriteria, searchValue)}
              >
                Search
              </button>
            </div>

            {/* Clear button */}
            <div className="col-md-1">
              <button
                className="btn btn-danger w-100"
                onClick={() => handleClearChange(null, null)}
              >
                Clear
              </button>
            </div>

            {/* Add Student button */}
            <div className="col-md-2 text-end">
              <Button
                variant="btn btn-secondary w-100"
                onClick={onAddNewStudent}
              >
                Add Student
              </Button>
            </div>

          </div>
        </>
      )}

      <Table striped bordered hover style={{
        tableLayout: "fixed",
        width: "100%",
      }}>
        <thead className="thead-dark">
          <tr>
            <th style={{ width: "50px" }}>#</th>
            <th style={{ width: "70px" }}>Roll No</th>
            <th style={{ width: "80px" }}>GR No</th>
            {/* <th style={{ width: "120px" }}>Apaar ID</th> */}
            <th style={{ width: "250px" }}>Name</th>
            <th style={{ width: "150px" }}>
              Stream,<br></br> Standard,<br></br> Section
            </th>
            <th style={{ width: "120px" }}>Aadhaar No</th>
            <th style={{ width: "120px" }}>Phone</th>
            <th style={{ width: "120px" }}>Password</th>
            <th style={{ width: "120px" }}>Reg. Details</th>
            <th
              style={{
                textAlign: "center",
                minWidth: role === "ADMIN" ? "420px" : "320px",
              }}
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {currentData.map((item, index) => (
            <tr key={item.studentId}>
              <td>{(currentPage - 1) * PageSize + (index + 1)}</td>
              <td>{item.rollNo}</td>
              <td>{item.generalRegisterNo}</td>
              {/* <td>{item.apaarId}</td> */}
              <td style={{
                whiteSpace: "normal", wordBreak: "breakWord", overflowWrap: "breakWord", maxWidth: "200px"
              }}>
                {`${item.firstName.toUpperCase()} ${item.middleName.toUpperCase()} ${item.lastName.toUpperCase()}`.trim()}
              </td>
              <td>
                {item.streamName && item.streamName} -{" "}
                {item.standardName && item.standardName} -
                {item.sectionName && item.sectionName}
              </td>
              <td>{item.uidNo}</td>
              <td>{item.studentContactNumber}</td>
              <td>{item.password}</td>
              {/* <td>{item.createdOn?.substring(0,10)}</td> */}
              <td>{
                (() => {
                  const d = new Date(item.createdOn);
                  const pad = (n) => String(n).padStart(2, "0");

                  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
                })()
              }</td>

              <td
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "5px",
                  alignItems: "center",
                }}
              >
                {/* ================= ADMIN ================= */}
                {role === "ADMIN" && (
                  <>
                    <Button
                      size="sm"
                      className="px-2 py-1"
                      variant="warning"
                      onClick={() => onEdit(item.studentId)}
                      title="Personal Details"
                    >
                      <BsPersonBadge size={16} />
                    </Button>

                    <Button
                      size="sm"
                      className="px-2 py-1"
                      variant="secondary"
                      onClick={() =>
                        onOtherDetailsEdit(item.studentId, item.schoolId)
                      }
                      title="Other Details"
                    >
                      <BsPersonVcard size={16} />
                    </Button>

                    <Button
                      size="sm"
                      className="px-2 py-1"
                      style={{ backgroundColor: "purple" }} // Custom color for info variant
                      onClick={() => onDocsView(item.studentId)}
                      title="Documents"
                    >
                      <BsFileEarmarkText size={16} />
                    </Button>

                    <Button
                      size="sm"
                      className="px-2 py-1"
                      variant="info"
                      onClick={() => onLCOLView(item.studentId)}
                      title="LC / OL Documents"
                    >
                      <BsClipboardCheck size={16} />
                    </Button>

                    <Button
                      size="sm"
                      className="px-2 py-1"
                      variant="success"
                      onClick={() => onView(item.studentId)}
                      title="View Student"
                    >
                      <BsEye size={16} />
                    </Button>

                    {/* STATUS */}
                    {/* {item.status === "REJECTED" ? (
                      <Button
                        size="sm"
                        className="px-2 py-1"
                        variant="danger"
                        onClick={() => handleOpenStatusModal(item.studentId)}
                        title={`Status: ${item.status}`}
                      >
                        REJ
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        className="px-2 py-1"
                        variant={
                          item.status === "APPROVED" ? "success" : "primary"
                        }
                        onClick={() => handleOpenStatusModal(item.studentId)}
                      >
                        {item.status === "APPROVED" ? "APP" : "Status"}
                      </Button>
                    )} */}

                    <Button
                      size="sm"
                      className="px-2 py-1"
                      variant={
                        item.status === "REJECTED"
                          ? "danger"
                          : item.status === "APPROVED"
                            ? "success"
                            : "primary"
                      }
                      onClick={() => handleOpenStatusModal(item.studentId)}
                      title={`Status: ${item.status}`}
                    >
                      {item.status === "REJECTED" ? (
                        <BsXCircle size={16} />
                      ) : item.status === "APPROVED" ? (
                        <BsCheckCircle size={16} />
                      ) : (
                        <BsArrowRepeat size={16} />
                      )}
                    </Button>

                    <Button
                      size="sm"
                      className="px-2 py-1"
                      variant="danger"
                      onClick={() => onDelete(item.studentId)}
                      title="Delete Student"
                    >
                      <BsTrash size={16} />
                    </Button>
                  </>
                )}

                {/* ================= STUDENT / TEACHER ================= */}
                {(role === "STUDENT" || role === "TEACHER") && (
                  <>
                    {/* Show edit buttons only when NOT APPROVED */}
                    {item.status !== "APPROVED" && (
                      <>
                        <Button
                          size="sm"
                          className="px-2 py-1"
                          variant="warning"
                          onClick={() => onEdit(item.studentId)}
                          title="Personal Details"
                        >
                          PP
                        </Button>

                        <Button
                          size="sm"
                          className="px-2 py-1"
                          variant="secondary"
                          onClick={() =>
                            onOtherDetailsEdit(item.studentId, item.schoolId)
                          }
                          title="Other Details"
                        >
                          OP
                        </Button>

                        <Button
                          size="sm"
                          className="px-2 py-1"
                          variant="info"
                          onClick={() => onDocsView(item.studentId)}
                        >
                          Docs
                        </Button>

                        {/* STATUS */}
                        {role === "TEACHER" &&
                          (item.status === "REJECTED" ? (
                            <Button
                              size="sm"
                              className="px-2 py-1"
                              variant="danger"
                              onClick={() => handleOpenStatusModal(item.studentId)}
                            >
                              REJ
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              className="px-2 py-1"
                              variant={item.status === "APPROVED" ? "success" : "primary"}
                              onClick={() => handleOpenStatusModal(item.studentId)}
                            >
                              {item.status === "APPROVED" ? "APP" : "Status"}
                            </Button>
                          ))}
                      </>
                    )}

                    {/* View is ALWAYS available */}
                    <Button
                      size="sm"
                      className="px-2 py-1"
                      variant="success"
                      onClick={() => onView(item.studentId)}
                    >
                      View
                    </Button>
                  </>
                )}
              </td>

            </tr>
          ))}
        </tbody>
      </Table >

      {/* Pagination Controls */}
      < Pagination className="justify-content-center" >
        <Pagination.First
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        />
        <Pagination.Prev
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {
          [...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))
        }
        <Pagination.Next
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
        <Pagination.Last
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        />
      </Pagination >

      {/* Status Modal */}
      < Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Update Student Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="statusSelect">
            <Form.Label>Select Status</Form.Label>
            <Form.Control as="select" onChange={handleStatusChange}>
              <option value="">--Select--</option>
              <option value="APPROVED">Approved</option>
              <option value="REJECTED">Rejected</option>
              <option value="PENDING">Pending</option>
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmitStatus}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal >
    </>
  );
};

export default PersonalDetailsList;
